// components/LoginForm.js - FIXED USER DATA STRUCTURE
import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { MyContext } from "../../../src/App";
import { postData } from "../../utils/api";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import googleIcon from "../../assets/images/googlereg.png";
import firebase from "../../firebase";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";

const provider = new GoogleAuthProvider();
const auth = getAuth();

const LoginForm = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const context = useContext(MyContext);

  const [formFields, setFormFields] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormFields({ ...formFields, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!formFields.email) {
        context.setAlertBox({
          open: true,
          error: true,
          msg: "Email is required",
        });
        return;
      }
      if (!formFields.password) {
        context.setAlertBox({
          open: true,
          error: true,
          msg: "Password is required",
        });
        return;
      }

      setIsLoading(true);

      const payload = {
        email: formFields.email,
        password: formFields.password,
      };

      const res = await postData("/api/users/signin", payload);

      if (!res.error) {
        context.setAlertBox({
          open: true,
          error: false,
          msg: "Login Successful!",
        });
        localStorage.setItem("token", res.token);
        
        // FIXED: Ensure consistent user data structure with proper ID mapping
        const userData = {
          name: res.user?.name,
          email: res.user?.email,
          // Map the database _id to userId for consistency with Google auth
          _id: res.user?._id,
          id: res.user?._id, 
          userId: res.user?._id, // This is what getCurrentUser() expects
          images: res.user?.images,
          phone: res.user?.phone,
          role: res.user?.role || "user",
          isActive: res.user?.isActive
        };


        
        localStorage.setItem("user", JSON.stringify(userData));

        context.setIsLoging(true);

        if (context.getCartData) {
          context.getCartData();
        }

        setTimeout(() => navigate("/"), 1500);
      } else {
        context.setAlertBox({
          open: true,
          error: true,
          msg: res.msg || "Login Failed",
        });
      }
    } catch (err) {
      context.setAlertBox({ open: true, error: true, msg: "Network Error" });
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const signInWithGoogle = () => {
    context.setIsLoading(true);
    signInWithPopup(auth, provider)
      .then((result) => {
        const user = result.user;
        const fields = {
          name: user.displayName,
          email: user.email,
          password: "",
          images: user.photoURL,
          phone: user.phoneNumber || "",
          isAdmin: false,
        };

        postData("/api/users/authWithGoogle", fields).then((res) => {
          if (!res.error) {
            localStorage.setItem("token", res.token);
            
            // FIXED: Better user data handling with proper fallbacks
            const userData = {
              name: res.user?.name || user.displayName,
              email: res.user?.email || user.email,
              // Use multiple fallbacks to ensure we get a valid user ID
              _id: res.user?._id || res.user?.id || res.user?.userId || user.uid,
              id: res.user?.id || res.user?._id || res.user?.userId || user.uid,
              userId: res.user?.userId || res.user?.id || res.user?._id || user.uid,
              images: res.user?.images || user.photoURL,
            };


            
            localStorage.setItem("user", JSON.stringify(userData));

            context.setIsLoging(true);

            if (context.getCartData) {
              context.getCartData();
            }

            context.setAlertBox({ open: true, error: false, msg: res.msg });
            setTimeout(() => {
              context.setIsLoading(false);
              navigate("/");
            }, 2000);
          } else {
            context.setAlertBox({ open: true, error: true, msg: res.msg });
            context.setIsLoading(false);
          }
        }).catch((apiErr) => {
          console.error("API Error:", apiErr);
          context.setAlertBox({ 
            open: true, 
            error: true, 
            msg: "Failed to authenticate with server" 
          });
          context.setIsLoading(false);
        });
      })
      .catch((err) => {
        console.error("Google Auth Error:", err);
        context.setAlertBox({ 
          open: true, 
          error: true, 
          msg: "Google authentication failed" 
        });
        context.setIsLoading(false);
      });
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div className="col-md-6 col-lg-5 shadow p-4 rounded bg-white">
        <h3 className="text-center mb-4">Welcome Back</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-floating mb-3">
            <input
              type="email"
              className="form-control"
              id="email"
              name="email"
              placeholder="Email"
              value={formFields.email}
              onChange={handleChange}
              required
            />
            <label htmlFor="email">Email Address</label>
          </div>

          <div className="form-floating mb-3 position-relative">
            <input
              type={showPassword ? "text" : "password"}
              className="form-control"
              id="password"
              name="password"
              placeholder="Password"
              value={formFields.password}
              onChange={handleChange}
              required
            />
            <label htmlFor="password">Password</label>
            <span
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: "absolute",
                right: "15px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                color: "#555",
              }}
            >
              {showPassword ? "Hide" : "Show"}
            </span>
          </div>

          <button type="submit" className="btn btn-success w-100 mt-4" disabled={isLoading}>
            {isLoading ? <CircularProgress size={24} /> : "Login"}
          </button>

          <p className="mt-3 text-center">
            Don't have an account? <Link to="/signup">Create Account</Link>
          </p>
          
          <div className="text-center mt-3">
            <p>Or </p>
            <button
              type="button"
              className="btn btn-outline-light border w-100 d-flex align-items-center justify-content-center"
              style={{ gap: "10px" }}
              onClick={signInWithGoogle}
              disabled={isLoading}
            >
              <img src={googleIcon} alt="Google" style={{ height: "20px" }} />
              <p style={{ color: "black", margin: 0 }}>Continue with Google</p>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;